import {
  ExtendedWarrantyDealerInformation,
  MaintenancePeriodUnit,
  MaintenanceRateUnit,
  OrganizationMaintenanceSettingsV2Value,
  ProgramType,
  ProgramTypeLabels,
  WarrantyContractSkuTermMapping,
} from 'types';

import { WarrantyRow } from './getWarrantyRows';

export const formatContractSkuTermMappings = (ewdi: ExtendedWarrantyDealerInformation): string => {
  if (ewdi?.contractSkuTermMappings?.length) {
    return ewdi.contractSkuTermMappings
      .map(
        (mapping: WarrantyContractSkuTermMapping) =>
          `${ProgramTypeLabels[mapping.programType] || mapping.programType} ${mapping.term} yr: ${mapping.contractSku}`,
      )
      .join(', ');
  }

  return ewdi?.contractSku || '-';
};

export const getWarrantyRowContractSkuLines = (row: WarrantyRow): string[] => {
  const fullRow = row as ExtendedWarrantyDealerInformation & { programType: ProgramType };
  const mappings = fullRow.contractSkuTermMappings?.filter((m) => m.programType === row.programType) ?? [];

  if (mappings.length > 0) {
    return mappings.map((m) => `${m.term} yr: ${m.contractSku}`);
  }

  return [fullRow.contractSku || '-'];
};

const RATE_UNIT_SUFFIX: Record<MaintenanceRateUnit, string> = {
  [MaintenanceRateUnit.perSystem]: '/system',
  [MaintenanceRateUnit.hourly]: '/hr',
};

const formatCurrency = (amount: number): string =>
  amount.toLocaleString(undefined, { style: 'currency', currency: 'USD' });

export const formatMaintenanceRate = (value: OrganizationMaintenanceSettingsV2Value | undefined): string =>
  value?.maintenanceRate
    ? `${formatCurrency(value.maintenanceRate.amount)}${RATE_UNIT_SUFFIX[value.maintenanceRate.unit]}`
    : '-';

export const formatServiceRate = (value: OrganizationMaintenanceSettingsV2Value | undefined): string =>
  value?.serviceRate
    ? `${formatCurrency(value.serviceRate.amount)}${RATE_UNIT_SUFFIX[value.serviceRate.unit]}`
    : '-';

const PERIOD_UNIT_LABEL: Record<MaintenancePeriodUnit, string> = {
  [MaintenancePeriodUnit.year]: 'year',
  [MaintenancePeriodUnit.month]: 'month',
  [MaintenancePeriodUnit.day]: 'day',
};

export const formatMaintenanceCadence = (value: OrganizationMaintenanceSettingsV2Value | undefined): string => {
  if (!value?.cadence) return '-';
  const { times, per } = value.cadence;
  const unitLabel = PERIOD_UNIT_LABEL[per.unit];
  return `${times}x per ${per.amount} ${per.amount === 1 ? unitLabel : `${unitLabel}s`}`;
};
